import { get, IRequestOptions, post } from '@apis/api';
import { PageCommonResponse } from '@models/common';

import {
  SearchKeyword,
  SearchKeywordInfo,
  PopularKeywordInfo,
  SearchStyleClip,
  AgentPromptInfo,
  PopularBrandData,
} from '@wconcept/wconcept-common/models/renewal/search';

const baseURL = process.env.NEXT_PUBLIC_DISPLAY_API_GATEWAY_URL;
const options = {
  headers: {
    'Content-Type': 'application/json; charset=utf-8', // 필요에 따라 헤더 수정
    'DISPLAY-API-KEY': process.env.NEXT_PUBLIC_DISPLAY_API_GATEWAY_KEY || '',
  },
};

export interface SearchInitStyleClipsResponse extends PageCommonResponse {
  data: SearchStyleClip[];
}

export interface SearchInitRecoKeywordResponse extends PageCommonResponse {
  data: SearchKeyword[];
}

export interface SearchInitPopularKeywordResponse extends PageCommonResponse {
  data: PopularKeywordInfo;
}

export interface SearchInitPopularBrandResponse extends PageCommonResponse {
  data: PopularBrandData | null;
}

// eslint-disable-next-line prettier/prettier
export interface SearchInitSearchKeywordInputInfoResponse
  extends PageCommonResponse {
  data: SearchKeywordInfo;
}

export interface SearchInitAgentPromptListResponse extends PageCommonResponse {
  data: AgentPromptInfo;
}

// 추천 스타일링(스타일 클립) - 검색창 API
export const requestSearchInitStyleClip = async ({
  recommendItems,
}: {
  recommendItems: string[];
}) => {
  const { data } = await post<SearchInitStyleClipsResponse>({
    url: `/display/api/search/v1/styleclip/recommendations`,
    data: {
      recommendItems,
    },
    options,
    baseUrl: baseURL,
  });
  return data;
};

// 추천 검색어 조회 API
export const requestSearchInitRecoKeyword = async ({
  recommendKeywords,
  recommendItems,
}: {
  recommendKeywords: string[];
  recommendItems: string[];
}) => {
  const { data } = await post<SearchInitRecoKeywordResponse>({
    url: `/display/api/search/v1/keywords/recommendations`,
    data: {
      recommendKeywords,
      recommendItems,
    },
    options,
    baseUrl: baseURL,
  });
  return data;
};

// 인기 검색어 조회 API
export const requestSearchInitPopularKeyword = async () => {
  const { data } = await get<SearchInitPopularKeywordResponse>({
    url: `/display/api/search/v1/keywords/popular`,
    options,
    baseUrl: baseURL,
  });
  return data;
};

export const requestSearchInitPopularBrand = async () => {
  const { data } = await get<SearchInitPopularBrandResponse>({
    url: `/display/api/search/v1/brands/popular`,
    options,
    baseUrl: baseURL,
  });
  return data;
};

// 검색 키워드 조회 API
export const requestSearchInitSearchKeyword = async (
  optionParams: IRequestOptions = {}
) => {
  const { data } = await get<SearchInitSearchKeywordInputInfoResponse>({
    url: `/display/api/search/v1/keywords/pick`,
    options: { ...options, ...optionParams },
    baseUrl: baseURL,
  });
  return data;
};

// 진입 화면 프롬프트 목록 조회 (ai 에이전트)
export const requestSearchInitAgentPromptList = async () => {
  const { data } = await get<SearchInitAgentPromptListResponse>({
    url: `/display/api/agent/v1/prompts`,
    options,
    baseUrl: baseURL,
  });
  return data;
};
